import { useEffect, useRef } from "react";
import api from "../../services/api";
import { registerPushNotifications, isPushTokenRegisteredLocally } from "../../services/pushNotifications";

/**
 * Registers FCM once per sign-in session (not on every route change).
 */
export default function PushNotificationBootstrap() {
  const startedRef = useRef(false);

  useEffect(() => {
    if (!api.getToken()) return undefined;
    const role = api.getAuthRoleFromToken();
    if (!["CUSTOMER", "CAREGIVER", "CARE_MANAGER", "ADMIN", "OPS"].includes(role)) return undefined;
    if (startedRef.current) return undefined;
    startedRef.current = true;

    let cancelled = false;

    registerPushNotifications({ force: false })
      .then((result) => {
        if (cancelled) return;
        if (result?.ok) {
          console.info("[push] browser notifications ready");
          return;
        }
        if (result?.reason === "not_configured") {
          console.warn("[push] server push not configured");
          return;
        }
        if (result?.reason === "denied") {
          return;
        }
        if (
          typeof Notification !== "undefined" &&
          Notification.permission === "granted" &&
          !isPushTokenRegisteredLocally()
        ) {
          registerPushNotifications({ force: true })
            .then((retry) => {
              if (cancelled) return;
              if (retry?.ok) {
                console.info("[push] browser notifications ready after retry");
              } else if (retry?.reason && retry.reason !== "denied") {
                console.warn("[push] registration retry failed:", retry.reason.slice(0, 160));
              }
            })
            .catch(() => {});
        } else if (result?.reason) {
          console.info("[push] auto-registration skipped:", result.reason.slice(0, 120));
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
